import { useMutation } from '@tanstack/react-query'

import { usersPasswordResetTfaAppVerifyPost } from '@src/api'
import { DefaultApiUsersPasswordResetTfaAppVerifyPostRequest } from '@src/api/generated/iam'
import { useAxios } from '@src/hooks/use-axios'

export const useUsersPasswordResetTfaAppVerifyPost = () => {
  const { axiosInstance } = useAxios({ apiType: 'IAM' })

  return useMutation({
    mutationFn: (params: DefaultApiUsersPasswordResetTfaAppVerifyPostRequest) =>
      usersPasswordResetTfaAppVerifyPost(axiosInstance, params),
  })
}
